module.exports = __webpack_public_path__ + "c9a5959e2434397741f3a52beadfb0e0.svg";